import React, {useState, useRef, lazy, Suspense, useEffect} from 'react';
import {Route, Routes, useNavigate} from 'react-router-dom';
import {ProgressSpinner} from 'primereact/progressspinner';
import {Toast} from 'primereact/toast';
import {BlockUI} from 'primereact/blockui';
import {useDispatch, useSelector} from 'react-redux';
import Axios from "axios";
import jwt_decode from 'jwt-decode';
import AppContext from './app/shared/components/AppContext';
import ProtectedRoutes from './app/shared/handlers/ProtectedRoutes';
import RespondentSurvey from './app/pages/RespondentSuvey/RespondentSurvey';

import ResearchApi from './app/shared/services/ResearchApi';

import './App.scss';
import {onChangeLanguage, onChangeModalSubscription} from "./app/redux/actions/ActionApp";
import Homepage from "./app/pages/Home/Homepage";
import TermAndConditions from "./app/shared/components/termAndConditions";
import {useTranslation} from "react-i18next";
import MetaTags from 'react-meta-tags';

const LoginComponent = lazy(() => import('./app/pages/Login/Login'));
const SurveysComponent = lazy(() => import('./app/pages/Surveys/Surveys'));
const ProfileComponent = lazy(() => import('./app/pages/Profile/Profile'));
const NotFoundComponent = lazy(() => import('./app/pages/error/NotFound/NotFound'));

/*
Base APP for React projects
Add more comments here
Be happy
*/
function App() {

    const navigate = useNavigate();
    const { t } = useTranslation();
    const [ApiKey, setApiKey] = useState('');
    const [SocialLogin, setSocialLogin] = useState('');
    const toast6 = useRef(null);
    const loading = useSelector(selector => selector.reduceApp.loading);
    const dispatch = useDispatch();
    const isShowPay = useSelector(selector => selector.reduceApp.showPay);

    const changeModalSupbcription = () => {
        dispatch(onChangeModalSubscription());
    };
    const clearAll = () => {
        if (toast6.current) {
            toast6.current.clear();
        }
    }


    useEffect(() => ResearchApi(dispatch));

    const setApplyApiKey = (token, routerTo = false) => {
        return new Promise((resolve, reject) => {
            try {
                const userActiveResponse = jwt_decode(token);
                if (userActiveResponse.subscription_type === 'None' && !isShowPay) {
                    changeModalSupbcription();
                }
                setApiKey(token);
                setuserActive(userActiveResponse);
                const language = userActiveResponse['language'] === 'en-US' ? 'en' : 'es';
                dispatch(onChangeLanguage(language))
                localStorage.setItem('tokenMKT', token);
                if (routerTo) {
                    // TODO: Url Role
                    switch (userActiveResponse.role) {
                        case 'Admin':
                            navigate('/Survey', {replace: true});
                            break;
                        default:
                            navigate('/Survey', {replace: true});
                            break;
                    }
                }
                resolve(new Date())
            } catch (error) {
                reject('Error')
            }
        })


    }

    // type = 'alert' | 'success' | 'info'
    const notify6 = (type, title, msn) => {
        const configMsn = {
            severity: 'custom-6',
            closable: false,
            className: type === 'alert' ? 'bg-pink-200' : type === 'info' ? 'bg-blue-200' : 'bg-green-300',
            contentClassName: 'p-3',
            life: 3000,
            content: (
                <div className="flex align-items-start flex-1">
                    <i className={`pi ${type === 'alert' ? 'pi-ban' : type === 'info' ? 'pi-exclamation-circle' : 'pi-check'} text-blue-500 text-2xl mr-3`}></i>
                    <div>
                        <span className="text-xl font-medium text-900">{title}</span>
                        <p className="text-700 mt-3">{msn}</p>
                    </div>
                </div>
            )
        };
        clearAll()
        toast6.current.show(configMsn);
    }

    const [userActive, setuserActive] = useState(() => {
        const token = localStorage.getItem('tokenMKT');
        if (token != null) {
            Axios.defaults.baseURL = process.env.REACT_APP_API_ENDPOINT;
            Axios.defaults.headers.common['Authorization'] = `Bearer ${token}`;
            return jwt_decode(token);
        } else {
            return null;
        }
    });

    const appSettings = {
        ApiKeyName: ApiKey,
        SocialLoginName: SocialLogin,
        user: userActive,
        setuserActive,
        setApplyApiKey,
        setSocialLogin,
        notify6
    };

    const renderLoader = () => <BlockUI blocked={true} fullScreen> <ProgressSpinner/> </BlockUI>;

    return (
        <Suspense fallback={renderLoader()}>
            <MetaTags>
                <title>{t('SEO.TITLE')}</title>
                <meta name="description" content={t('SEO.TITLE')} />
            </MetaTags>


            <AppContext.Provider value={appSettings}>
                {
                    <Toast
                        key="block6"
                        style={{width: "30rem"}}
                        ref={toast6}
                        preventOpenDuplicates
                    />
                }
                {
                    <BlockUI blocked={loading} fullScreen>
                        {
                            loading ? <ProgressSpinner/> : <></>
                        }
                    </BlockUI>
                }
                <Routes>
                    <Route element={<ProtectedRoutes/>}>
                        <Route exact path="/" element={<Homepage/>}/>
                        <Route exact path="/Survey" element={<SurveysComponent/>}/>
                        <Route exact path="/ProfileInfo" element={<SurveysComponent/>}/>
                        <Route path="/NewSurvey" element={<SurveysComponent/>}/>
                        <Route path="/EditSurvey/:id_survey" element={<SurveysComponent/>}/>
                        <Route exact path="/Profile" element={<ProfileComponent/>}/>
                        <Route exact path="/surveys/:visible/:id_survey/:id_respondent/:code"
                               element={<RespondentSurvey/>}/>
                    </Route>
                    <Route exact path="/Register" element={<LoginComponent/>}/>
                    <Route exact path="/TerminosYCondiciones/:type" element={<TermAndConditions/>}/>
                    <Route exact path="/Login" element={<LoginComponent/>}/>
                    <Route exact path="/SuccessConfirm" element={<LoginComponent/>}/>
                    <Route exact path="/validactive/:iduser/:role/:idotp" element={<LoginComponent/>}/>
                    <Route exact path="/surveys/:visible/:id_survey/:code" element={<RespondentSurvey/>}/>
                    <Route exact path="/successful-payment" element={<NotFoundComponent
                        item={{tittle: 'Success !!', body: 'Success Payment.', sowButton: true}}/>}/>
                    <Route exact path="/failed-payment" element={<NotFoundComponent
                        item={{tittle: 'Failed :(', body: 'Faild Payment.', sowButton: true}}/>}/>
                    <Route exact path="/pending-payment" element={<NotFoundComponent
                        item={{tittle: 'Pending', body: 'Pending Payment.', sowButton: true}}/>}/>
                    <Route path="CompleteSurvey" element={<NotFoundComponent
                        item={{tittle: 'Thank you', body: 'The answers have been recorded.', sowButton: false}}/>}/>
                    <Route path="*" element={<NotFoundComponent
                        item={{tittle: 404, body: 'Resource Not Found', sowButton: false}}/>}/>
                </Routes>
            </AppContext.Provider>
        </Suspense>


    );
}

export default App;
